"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePageDrop = void 0;

var React = __importStar(require("react"));

var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var createProcess = function createProcess(options) {
  return function (dataTransfer, event) {
    var uri = !!dataTransfer ? dataTransfer.getData('text/uri-list') : '';

    if (uri.length > 0) {
      (options.onUri || utils_1.noop)(uri, event);
    } else if (!!dataTransfer && !!dataTransfer.files && dataTransfer.files.length > 0) {
      (options.onFiles || utils_1.noop)(Array.from(dataTransfer.files), event);
    } else if (!!event.clipboardData) {
      var text = event.clipboardData.getData('text');
      (options.onText || utils_1.noop)(text, event);
    }
  };
};

function usePageDrop(options, args) {
  if (options === void 0) {
    options = {};
  }

  if (args === void 0) {
    args = [];
  }

  var onFiles = options.onFiles,
      onText = options.onText,
      onUri = options.onUri;

  var _a = React.useState(false),
      over = _a[0],
      setOverRaw = _a[1];

  var setOver = React.useCallback(setOverRaw, []);
  var process = React.useMemo(function () {
    return createProcess(options);
  }, [onFiles, onText, onUri]);
  React.useEffect(function () {
    if (utils_1.isBrowser) {
      var onDragOver_1 = function onDragOver_1(event) {
        event.preventDefault();
        setOver(true);
      };

      var onDragEnter_1 = function onDragEnter_1(event) {
        event.preventDefault();
        setOver(true);
      };

      var onDragLeave_1 = function onDragLeave_1() {
        setOver(false);
      };

      var onDragExit_1 = function onDragExit_1() {
        setOver(false);
      };

      var onDrop_1 = function onDrop_1(event) {
        event.preventDefault();
        setOver(false);
        process(event.dataTransfer, event);
      };

      var onPaste_1 = function onPaste_1(event) {
        process(event.clipboardData, event);
      };

      document.addEventListener('dragover', onDragOver_1);
      document.addEventListener('dragenter', onDragEnter_1);
      document.addEventListener('dragleave', onDragLeave_1);
      document.addEventListener('dragexit', onDragExit_1);
      document.addEventListener('drop', onDrop_1);

      if (!!onText) {
        document.addEventListener('paste', onPaste_1);
      }

      return function cleanup() {
        document.removeEventListener('dragover', onDragOver_1);
        document.removeEventListener('dragover', onDragOver_1);
        document.removeEventListener('dragenter', onDragEnter_1);
        document.removeEventListener('dragleave', onDragLeave_1);
        document.removeEventListener('dragexit', onDragExit_1);
        document.removeEventListener('drop', onDrop_1);

        if (!!onText) {
          document.removeEventListener('paste', onPaste_1);
        }
      };
    }
  }, __spreadArrays([process], args));
  return {
    over: over
  };
}

exports.usePageDrop = usePageDrop;